import AlertModalWeb from 'design-system/AlertModalWeb';
const alert = (title, message, buttons) => {
    AlertModalWeb.show(title, message, buttons);
};
export default { alert };
